import React from 'react';


const Shadow = ({show, toggle}) => {
    let style = ""
    if(show === false){
        style = 'hidden';
    }else{
        style = 'fixed w-full h-screen bg-black z-40 bg-opacity-50 ';
    }
    return (
        <div className={style} onClick={toggle}>
        </div>
    );
}

export default Shadow;